import React from "react";
import { Box } from "grid-styled";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { compose } from "redux";
import { validate as buildValidations } from "validate-redux-form";
import { notEmpty } from "../../utils/validation";
import H1 from "../Heading";
import { FormSection, InputContainer, Select } from "../forms";
import Button from "../Button";
import { SERVICE_TYPES } from "../../constants";
import NewSaleOptionsFormSection from "./NewSaleOptionsFormSection";
import SalesDrawingOptionsFormSection from "./SalesDrawingOptionsFormSection";

const validate = values => {
  let errors = buildValidations(values, {
    serviceType: notEmpty()("Please select a service type.")
  });

  if (values.serviceType === "New Sale") {
    errors = {
      ...buildValidations(values, {
        options: {
          serviceLevel: notEmpty()("Please select a service level.")
        }
      })
    };
  }

  if (
    values.serviceType === "Sales Drawing" ||
    values.serviceType === "Redraw"
  ) {
    errors = {
      ...buildValidations(values, {
        options: {
          drawingDepth: notEmpty()("Please select a drawing depth.")
        }
      })
    };
  }

  return errors;
};

const NewSaleOptions = () => (
  <FormSection title="Service Options">
    <NewSaleOptionsFormSection />
  </FormSection>
);

const SalesDrawingOptions = () => (
  <FormSection title="Service Options">
    <SalesDrawingOptionsFormSection />
  </FormSection>
);

const filteredServiceTypes = slug =>
  SERVICE_TYPES.filter(
    service => (slug && service.shouldShow ? service.shouldShow(slug) : true)
  );

const NewServiceForm = ({
  handleSubmit,
  pristine,
  submitting,
  serviceType,
  franchiseSlug
}) => (
  <form onSubmit={handleSubmit}>
    <H1>Request a new service</H1>
    <FormSection title="Service Type">
      <Box pb={2}>
        <Field
          name="serviceType"
          labelText="Which service would you like?"
          placeholder="Select a service type"
          component={InputContainer}
          fieldComponent={Select}
          options={filteredServiceTypes(franchiseSlug)}
          labelKey="name"
          valueKey="name"
        />
      </Box>
    </FormSection>
    {serviceType === "New Sale" && <NewSaleOptions />}
    {["Sales Drawing", "Redraw"].indexOf(serviceType) > -1 && (
      <SalesDrawingOptions />
    )}
    <FormSection>
      <Button variant="primary" disabled={pristine || submitting} type="submit">
        {submitting ? "Creating service draft..." : "Create service draft"}
      </Button>
    </FormSection>
  </form>
);

const formName = "newService";
const selector = formValueSelector(formName);
const enhance = compose(
  connect(state => ({
    serviceType: selector(state, "serviceType")
  })),
  reduxForm({
    form: formName,
    validate
  })
);
export default enhance(NewServiceForm);



// WEBPACK FOOTER //
// ./src/components/services/NewServiceForm.js